import { CloseIcon } from 'src/assets/icons/customIcons/Close'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useFormData } from './Form'

export function GeneralFormError({ messages }: { readonly messages: readonly string[] }): JSX.Element | null {
  const t = useTranslatable()

  if (messages.length === 0) return null
  if (messages.length === 1) {
    return (
      <div
        className="form-general-error my-3 flex items-center rounded-[4px] bg-seconderyRed/20 px-4 py-3 text-primaryRed"
        role="alert"
      >
        <div>
          <div className="mr-[11px] rounded-full bg-primaryRed p-1">
            <CloseIcon width="10" height="10" />
          </div>
        </div>
        <div>
          <div className="mb-1 font-bold">{t('error:an_error_occurred')}</div>
          {messages[0]}
        </div>
      </div>
    )
  }

  return (
    <div
      className="form-general-error my-3 flex items-center rounded-[4px] bg-seconderyRed/20 px-4 py-3 font-bold text-primaryRed"
      role="alert"
    >
      <div>
        <div className="mr-[11px] rounded-full bg-primaryRed p-1">
          <CloseIcon width="12" />
        </div>
      </div>
      <div>
        <div className="mb-1 font-bold">
          {t('error:an_error_occurred')}
          <ul>
            {messages.map((text, index) => (
              <li key={index}>{text}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export function FormError(): JSX.Element | null {
  const [formData] = useFormData()
  return <GeneralFormError messages={formData.errors.general} />
}
